module.exports = __webpack_public_path__ + "static/media/wmsui32_3934.c2ef0510.ico";